module.exports = __webpack_public_path__ + "fonts/ToyotaDisplay_Bd.dd93e37.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/ToyotaDisplay_Bd.ttf
// module id = QNSs
// module chunks = 13